import { Action } from '@ngrx/store';

export const SET_OPTED_AS_GUEST = '[ACCOUNT_LOGIN] Set opted as guest';

export class SetOptedAsGuest implements Action {
    readonly type = SET_OPTED_AS_GUEST;
    constructor(public payload: boolean) {
    }
}

export type AccountLoginActions = SetOptedAsGuest;
